import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { load, updateFilter } from 'Actions/mailTemplate';
import { pageTitleDecorator } from 'Decorators';
import { QueryFilterType, DataTableMetadataType, MailTemplateType } from 'Types';
import { DATA_TABLE_COLUMN_TYPE_LINK, DATA_TABLE_COLUMN_TYPE_DATE } from 'Constants';

import DataTable from 'Components/DataTable';
import Header from 'Components/Header/Header';

@connect(
    store => ({
        data: store.mailTemplateList.data,
        filter: store.mailTemplateList.filter,
        metadata: store.mailTemplateList.metadata,
    }),
    dispatch => ({
        loadMails: filter => dispatch(load(filter)),
        updateFilter: filter => dispatch(updateFilter(filter)),
    })
)
@pageTitleDecorator('settings.mails')
export default class SettingsMailsList extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        data: PropTypes.arrayOf(MailTemplateType),
        filter: QueryFilterType,
        metadata: DataTableMetadataType,
        loadMails: PropTypes.func.isRequired,
        updateFilter: PropTypes.func.isRequired,
    };

    getColumns = () => {
        return [
            {
                key: 'id',
                title: 'data_table.id',
                sortable: true,
            },
            {
                key: 'title',
                title: 'data_table.title',
                sortable: true,
                type: DATA_TABLE_COLUMN_TYPE_LINK,
                link: {
                    to: '/settings/mails/:id',
                    placeholders: {
                        id: item => item.id,
                    },
                },
            },
            {
                key: 'alias',
                title: 'data_table.alias',
                sortable: true,
            },
            {
                key: 'updated_at',
                title: 'data_table.submission_updated_at',
                sortable: true,
                type: DATA_TABLE_COLUMN_TYPE_DATE,
            },
        ];
    };

    render() {
        const { data, filter, loadMails, metadata, updateFilter } = this.props;

        return (
            <div>
                <Header title="title.settings.mails" />
                <DataTable
                    columns={this.getColumns()}
                    metadata={metadata}
                    data={data}
                    filter={filter}
                    load={loadMails}
                    updateFilter={updateFilter}
                    icon={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/containers/SettingsMailsList.jsx